import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import { DeleteDialogComponent } from "../../common-ui/delete-dialog/index";
import { MatDialog } from '@angular/material/dialog';

import { trigger, state, style, transition, animate } from '@angular/animations';
import { SnackService } from '../../services';
import { ProviderService } from '../../api';

@Component({
  selector: 'school-availability-lists',
  templateUrl: './availability-lists.component.html',
  styleUrls: ['./availability-lists.component.scss'],
  animations: [
      trigger('detailExpand', [
        state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
        state('expanded', style({height: '*'})),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ]),
    ],
})
export class AvailabilityListsComponent implements OnInit {


    @Input() EditIconPath: string;
    @Input() DeleteIconPath: string;
    @Input() PageSize_Options: any;
    @Input() Page_Size: any;
    @Input() user_id: any;
    @Input() TimeSlots: boolean = true;
    @Input() QueueSlots: boolean = true;

    expandedElement: any;
    thisnow = new Date();
    todayDate = (this.thisnow.getMonth() + 1) + "/" + this.thisnow.getDate() + "/" + this.thisnow.getFullYear();


    @ViewChild(MatPaginator)
    paginator: MatPaginator;
    @ViewChild(MatSort)
    sort: MatSort;
    isCreateAvailability = false;

    sourceList: any;

    editicon: string;
    deleteicon: string;

    FormStatus: boolean = false;
    availabilityId: number;

    availability_displayedColumns: string[] = [
        "id",
        "day",
        "actions",
    ];

    availabilitydataSource = new MatTableDataSource;

    constructor(
        private dialog: MatDialog,
        private _snackService: SnackService,
        private _userService: ProviderService) { }

    ngOnInit(): void {
        this.availabilitydataSource.paginator = this.paginator;
        this.availabilitydataSource.sort = this.sort;
        this.editicon = this.EditIconPath;
        this.deleteicon = this.DeleteIconPath;
        if(this.user_id){
          this.user_id = (this.user_id).replace(/['"]+/g, '');
        }

        this.getAvailabilityList();
    }




    showcreateAvailability(actionType: any, availability_id: any) {
        this.isCreateAvailability = true;

        if (actionType == "update") {
            this.FormStatus = true;
            this.availabilityId = availability_id;
        } else {
            this.FormStatus = false;
            this.availabilityId = availability_id;
        }
    }


    showAvailabilitylist() {
        this.isCreateAvailability = false;
        this.FormStatus = false;
        this.getAvailabilityList();
    }

    getAvailabilityList(): void {


        this._userService.getProvidersProfile(this.user_id).subscribe(

            result => {

                this.availabilitydataSource = new MatTableDataSource(result.body.data.availabilities);


            }, error => {
                console.log(error);
            });

    }



    EditAvailability(id: any): void {

        const dialogRef = this.dialog.open(DeleteDialogComponent, {
            width: '450px',
            data: {
                message: 'update Availability Status?',
                deleteId: id,
                buttonText: {
                    ok: 'Yes',
                    cancel: 'No'
                }
            }
        });

    }

}
